import { render, staticRenderFns } from "./HeadlineWithTextAndHorizontalCards.vue?vue&type=template&id=3f4e86be&"
import script from "./HeadlineWithTextAndHorizontalCards.vue?vue&type=script&lang=js&"
export * from "./HeadlineWithTextAndHorizontalCards.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {SectionBaseSection: require('/usr/src/app/components/sections/BaseSection.vue').default})
